import React, { FC } from 'react';
import { hot } from 'react-hot-loader/root';
import { Route } from 'react-router-dom';

import { NotFound, QueryManager } from 'components';
import { useAuth } from 'hooks';
import { GetCurrentUserFeedComponent } from 'api';

import Providers from './Providers';

const ProtectedIndex: FC = ({ children }) => {
  const auth = useAuth();
  const variables = { user_id: auth.data.id };

  return (
    <GetCurrentUserFeedComponent variables={variables}>
      {queryResult => (
        <QueryManager {...queryResult}>
          {({ data }) => {
            if (!data || !data.getByUserFeed) {
              return null;
            }

            const { getByUserFeed } = data;

            if (!getByUserFeed) {
              return <Route component={NotFound} />;
            }

            return <Providers queryResult={queryResult}>{children}</Providers>;
          }}
        </QueryManager>
      )}
    </GetCurrentUserFeedComponent>
  );
};

export default hot(ProtectedIndex);
